const displayCode = {
  'permission': {
    color: '81, 216, 255',
    contrast: '0%'
  },
  'error' : {
    color: '0, 12, 36',
    contrast: '250%'
  },
  '01' : {
    color: '70, 199, 255',
    contrast: '25%'
  },
  '02' : {
    color: '61, 181, 255',
    contrast: '50%'
  },
  '03' : {
    color: '35, 155, 254',
    contrast: '75%'
  },
  '04' : {
    color: '22, 114, 249',
    contrast: '100%'
  },
  '09' : {
    color: '4, 78, 227',
    contrast: '125%'
  },
  '10' : {
    color: '35, 39, 141',
    contrast: '150%'
  },
  '11' : {
    color: '18, 28, 123',
    contrast: '175%'
  },
  '13' : {
    color: '10, 24, 95',
    contrast: '200%'
  },
  '50' : {
    color: '1, 17, 64',
    contrast: '225%'
  }
};

const changeBackground = (source = '') => {
  const { color, contrast } = displayCode[source];
  document.querySelector('.Background').style.backgroundColor = `rgba(${color}, 0.25)`;
  document.querySelector('.Background IMG').style.filter = `brightness(200%) contrast(${contrast})`;
};

const changeNumber = (number = 0) => number < 10 ? `0${number}` : number;

const toggleTemperature = (scale = '', temperature = 0) => scale === 'C' ? temperature.toFixed(0) : (temperature * 9 / 5 + 32).toFixed(0);

const createDiv = (total = 0) => Array(total).fill(<div><span /></div>);

export { changeBackground, createDiv, changeNumber, toggleTemperature };